import { render, staticRenderFns } from "./VendorRatesCounterViewer.vue?vue&type=template&id=55a5e08c&"
import script from "./VendorRatesCounterViewer.vue?vue&type=script&lang=js&"
export * from "./VendorRatesCounterViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports